import { defineMessage } from 'services/localization';

export const messages = {
    changeMatchingButtonTitle: defineMessage('change_matching'),
    allocatedAmountToBilledPOs: defineMessage('allocations_to_billed_pos'),
    allocatedAmount: defineMessage('allocated_amount'),
    remaining: defineMessage('remaining'),
    sectionHeaderText: defineMessage('bill_to_po_matching_1'),
    matchWithPO: defineMessage('match_with_po'),
    editMatching: defineMessage('edit_matching'),
    noMatchedPO: defineMessage('this_bill_is_not_curren_with_any_purchase_order'),
    showTable: defineMessage('matched_po'),
};
